import { Component, Input } from '@angular/core';

import { AppService } from '../../services/app.service';
import { SaidEventService } from '../../services/said-event.service';

import { StudentEventItem, SkillDetailItem, StudentEventSkill } from '../../models/SaidEvent';
import { SaidEventSkillDetailsComponent } from './said-event-skill-details.component';

import { Helpers } from './helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

const skillCache: { [skillId: string]: SkillDetailItem[] } = { };

@Component({
    selector: 'app-said-event-card',
    templateUrl: './said-event-card.component.html',
    styleUrls: ['./said-event-card.component.scss']
})
export class SaidEventCardComponent {
    constructor(
        public app: AppService,
        private service: SaidEventService,
        private modal: NgbModal
    ) { }

    @Input() data: StudentEventItem;
    @Input() studentId: string;

    get canBeRegistered(): boolean {
        return (
            this.data.GroupIsFull
            || this.data.Error != null
            || (!this.isAdmin && !this.data.StudentTestIsPassed && this.data.IsSupervised)
            || Helpers.validateDate(this.data.RegistrationOpenDate, this.data.RegistrationCloseDate)
        ) === false;
    }

    get canBeUnregistered(): boolean {
        return (
            this.data.Error != null
            || Helpers.validateDate(this.data.RegistrationOpenDate, this.data.RegistrationCloseDate)
        ) === false;
    }

    get isAdmin(): boolean {
        return this.app.currentUser?.isAdmin;
    }

    openSkill(skill: StudentEventSkill) {
        this.getSkillDetails(skill.Id).subscribe(details => {
            const ref = this.modal.open(SaidEventSkillDetailsComponent, {
                size: 'lg'
            });
            ref.componentInstance.data = { details };
        });
    }

    register() {
        const event = this.data;

        this.app.addLoading(this.service.register(this.studentId, event.EventId)).subscribe(result => {
            if (!result) {
                event.Error = null;
                event.IsSelected = true;
                event.ActualStudentCount++;
            } else {
                event.Error = result;
                this.app.showError(this.app.translate("said_events_reg_failed_message") + "<br/>" + result);
            }
        });
    }

    unregister() {
        const event = this.data;

        this.app.addLoading(this.service.unregister(this.studentId, event.EventId)).subscribe(result => {
            if (!result) {
                event.Error = null;
                event.IsSelected = false;
                event.ActualStudentCount--;
            } else {
                event.Error = result;
                this.app.showError(this.app.translate("said_events_unreg_failed_message") + "<br/>" + result);
            }
        });
    }

    private getSkillDetails(skillId: string) {
        const cached = skillCache[skillId];

        if (cached) {
            return of(cached);
        } else {
            return this.app.addLoading(this.service.getSkill(skillId)).pipe(tap(details => {
                skillCache[skillId] = details;
            }));
        }
    }
}
